import { AxiosInstance } from 'axios';
import { MealCheckRepository } from '@/model/repository/manager/dailyCheck/mealCheck/repository';
import { fetchWithKeepAlive } from '@/repository/manager/fetch';
import { serializeTopicsRequestParams } from '@/repository/manager/topics/serializeTopicsRequestParams';

export default (axios: AxiosInstance) =>
  (resource: string): MealCheckRepository => ({
    find(id) {
      return axios.get(`${resource}/${id}`);
    },
    search(params) {
      // search_id[] などの配列パラメータを AngularJS $http 互換（key[]=v1&key[]=v2）で直列化する
      return axios.get(`${resource}`, { params, paramsSerializer: serializeTopicsRequestParams });
    },
    post(payload) {
      return axios.post(`${resource}`, payload);
    },
    put({ id, ...body }) {
      return axios.put(`${resource}/${id}`, body);
    },
    bulkPost(payload) {
      return axios.post(`${resource}`, {
        ...payload,
        mode: ['update', 'update_multi'],
      });
    },
    postWithKeepAlive(payload) {
      return fetchWithKeepAlive(`${resource}?__env__=mgr&keepAlive=true`, 'POST', payload);
    },
    putWithKeepAlive({ id, ...body }) {
      return fetchWithKeepAlive(`${resource}/${id}?__env__=mgr&keepAlive=true`, 'PUT', body);
    },
  });
